import React from "react";
import clsx, { type ClassValue, } from "clsx";
import { twMerge, } from "tailwind-merge";

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// MUI v4 Toolbar regular:
//   xs: min-height 56px
//   @media (orientation: landscape) and (max-height: 600px): 48px
//   sm (>= 600px): 64px
// MUI v4 Toolbar dense: 48px em todos os tamanhos.
const variantMap = {
  regular: "min-h-14 [@media(orientation:landscape)and(max-height:600px)]:min-h-12 sm:min-h-16",
  dense: "min-h-12",
} as const;

interface ToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
  component?: React.ElementType;
  disableGutters?: boolean;
  variant?: keyof typeof variantMap;
  children?: React.ReactNode;
}

const Toolbar = React.forwardRef<HTMLDivElement, ToolbarProps>((props, ref) => {
  const {
    className,
    component: Component = "div",
    disableGutters = false,
    variant = "regular",
    ...other
  } = props;

  const classes = cn(
    // Base: flex em linha, alinhado verticalmente, posição relativa.
    "relative flex items-center",

    variantMap[variant],

    // Gutters: padding horizontal 16px (xs) e 24px (>= sm)
    !disableGutters && "px-4 sm:px-6",

    className
  );

  return <Component ref={ref} className={classes} {...other} />;
});

Toolbar.displayName = "Toolbar";

export default Toolbar;
